import React, { Fragment, useState } from 'react'
import DefaultAvatar from "../../images/default_avatar.jpg"
import { formatNumberShort } from '../../../utils/formatNumberShort';
import { Link } from 'react-router-dom';
const SingleUser = ({ PMM, index, totalPMMs, userType }) => {



    const [copied, setCopied] = useState(false);






    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    const displayIndex = String(totalPMMs - index).padStart(2, '0');







    return (
        <Fragment>
            <div className="flex w-[240%] lg:w-full py-[1vmax] border border-gray-100 border-l-[0.3vmax] border-l-indigo-600 bg-white rounded-xl shadow-sm mb-[0.5vmax] items-center transition-all hover:shadow-md" >
                {/* No. */}
                <div className="text-center flex-center items-center flex-[0.5] text-gray-500 font-bold text-[0.9vmax]" >
                    {displayIndex}
                </div>

                {/* Name / Email */}
                <div className="px-[1vmax] flex-[2] text-gray-700 text-[0.9vmax] flex gap-[1vmax] items-center" >
                    <div className="w-[2.5vmax] h-[2.5vmax] flex-shrink-0" >
                        <img src={PMM?.avatar_url || DefaultAvatar} alt="" className="w-full h-full rounded-full object-cover border border-gray-100" />
                    </div>
                    <div className="flex flex-col min-w-0">
                        <span className="text-gray-800 font-bold text-[0.95vmax] truncate" >{PMM?.name}</span>
                        <span className="lowercase text-gray-500 text-[0.85vmax] truncate" >{PMM?.email}</span>
                    </div>
                </div>

                {/* User ID */}
                <div className="flex-center px-[0.5vmax] flex-[1] text-gray-700 font-medium text-[0.9vmax] flex items-center justify-center gap-2" >
                    <span>{userType === "PMM" ? String(PMM?.pmm_id).padStart(2, '0') || "000" : PMM?.id || "000"}</span>
                    <button
                        onClick={() => handleCopy(userType === "PMM" ? PMM?.pmm_id || "000" : PMM?.id || "000")}
                        className="text-gray-400 hover:text-indigo-600 transition-colors"
                        title={copied ? "Copied" : "Copy"}
                    >
                        <i className={`fa-regular ${copied ? "fa-circle-check text-green-600" : "fa-copy"}`}></i>
                    </button>
                </div>

                {/* Total Pending */}
                <div className="text-center px-[0.5vmax] flex-[1] text-gray-700 font-bold text-[0.9vmax]" >
                    Rs. {userType === "PMM" ?
                        formatNumberShort(
                            Number(PMM.pmm_pending_pm_commission || 0)
                            +
                            Number(PMM.pmm_pending_portal_commission || 0)
                        )
                        :
                        formatNumberShort(Number(PMM.pending_pm_commission || 0))
                    }
                </div>

                {/* Total Paid */}
                <div className="text-center px-[0.5vmax] flex-[1] text-gray-700 font-bold text-[0.9vmax]" >
                    Rs. {userType === "PMM" ?
                        formatNumberShort(
                            Number(PMM.pmm_paid_pm_commission || 0)
                            +
                            Number(PMM.pmm_paid_portal_commission || 0)
                        )
                        :
                        formatNumberShort(Number(PMM.paid_pm_commission || 0))}
                </div>

                {/* Status */}
                <div className="flex-center px-[0.5vmax] flex-[1] flex items-center justify-center" >
                    <span className={`px-[0.8vmax] py-[0.3vmax] rounded-full text-[0.8vmax] font-bold uppercase tracking-wider
                        ${PMM?.status === "ACTIVE" ? "text-green-700 bg-green-50" :
                          PMM?.status === "BLOCKED" ? "text-red-700 bg-red-50" : "text-orange-700 bg-orange-50"}
                        `} 
                    >
                        {PMM?.status === "ACTIVE" ? "Active" :
                            PMM?.status === "BLOCKED" ? "Blocked" : "Suspended"
                        }
                    </span>
                </div>

                {/* Action */}
                <div className="flex-center px-[0.5vmax] flex-[1.5] flex items-center justify-center gap-[0.5vmax]" >
                    <Link to={`/orders/all-orders?${PMM?.role === "PMM" ? `seller_id=${PMM?.pmm_id}` : `pm_id=${PMM?.id}`}`} 
                          className="rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 px-[1vmax] py-[0.4vmax] text-[0.8vmax] font-bold transition-colors whitespace-nowrap" 
                    >
                        View Orders
                    </Link>
                    {PMM?.role === "PMM" &&
                        <Link to={`/products/all-products?seller_id=${PMM?.pmm_id}`} 
                              className="rounded-lg text-white bg-emerald-600 hover:bg-emerald-700 px-[1vmax] py-[0.4vmax] text-[0.8vmax] font-bold transition-colors whitespace-nowrap" 
                        >
                            View Products
                        </Link>
                    }
                </div>
            </div>
        </Fragment>
    )
}

export default SingleUser